import { render, staticRenderFns } from "./ScalevReport.vue?vue&type=template&id=5659824b&"
import script from "./ScalevReport.vue?vue&type=script&lang=js&"
export * from "./ScalevReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports